<!-- <owl-carousel-o [options]="customOptions">
 
    <ng-template carouselSlide *ngFor="let slide of slidesStore" [id]="slide.id">
        <div class="slide {{slide.id}}">
            <img [src]="slide.src" [alt]="slide.alt" [title]="slide.title">
        </div>      
    </ng-template>
   
</owl-carousel-o> -->
<div class="homeslider">
    <div class="top-banner">
        <div class="container">
            <div class="col-md-4 my-card">
                <div class="card" style="width: 18rem;">
                    <img src="../../assets/images/homepage/myCard.jpg" class="card-img-top" alt="...">
                    <div class="card-body">
                      <h4 class="card-text">Welcome to My portfolio site.</h4>
                    </div>
                  </div>
            </div>
        </div>
    </div>
    <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide>
            <div class="slide">
                <img src="../../assets/images/homepage/homepage-slider-01.jpg">
            </div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="slide">
                <img src="../../assets/images/homepage/homepage-slider-02.jpg">
            </div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="slide">
                <img src="../../assets/images/homepage/homepage-slider-03.jpg">
            </div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="slide">
                <img src="../../assets/images/homepage/homepage-slider-04.jpg">
            </div>
        </ng-template>    
    </owl-carousel-o>
</div>